var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaflat_map"},[_c('TitleName',{attrs:{"TitleName":_vm.TitleName}}),_c('div',{staticClass:"map",attrs:{"id":"maps"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }